import { render, staticRenderFns } from "./AttendancePayrollPosting.vue?vue&type=template&id=cc9b486a&scoped=true"
import script from "./AttendancePayrollPosting.vue?vue&type=script&lang=js"
export * from "./AttendancePayrollPosting.vue?vue&type=script&lang=js"
import style0 from "./AttendancePayrollPosting.vue?vue&type=style&index=0&id=cc9b486a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9b486a",
  null
  
)

export default component.exports